import { useState, useEffect } from "react";
import { useApp } from "../APIHelpers/AppContext";
import { LiaHandsHelpingSolid } from "react-icons/lia";
import { GrDocumentPerformance } from "react-icons/gr";
import { FiBell, FiPlus, FiSettings, FiUsers } from "react-icons/fi";
import HRManagement from "./HRManagement/HRManagement";
import CRMManagement from "./CRMManagement/CRMManagement";
import ProfilePopover from "./UserProfile/ProfilePopover";
import TeamWorkspace from "./TeamManagement/TeamWorkspace";
import AccountManagement from "./AccountManagement/AccountManagement";

export const workspaceItems = [
  { key: "team", label: "Team", icon: <FiUsers /> },
  { key: "hrManagement", label: "HR", icon: <LiaHandsHelpingSolid /> },
  { key: "crmManagement", label: "CRM", icon: <GrDocumentPerformance /> },
  { key: "activity", label: "Activity", icon: <FiBell /> },
  { key: "accountManagement", label: "Settings", icon: <FiSettings /> },
];

const AppLayout = () => {
  const { currentUserData } = useApp();

  const [active, setActive] = useState("team");
  const [showProfile, setShowProfile] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);

  return (
    <div className="slack-layout">
      <aside className="workspace-bar blank p-2">
        <div className="workspace-avatar">WB</div>

        <div className="workspace-icons">
          {workspaceItems.map((item) => (
            <div
              key={item.key}
              className={`workspace-item ${active === item.key ? "active" : ""
                }`}
              onClick={() => setActive(item.key)}
            >
              {item.icon}
              <span>{item.label}</span>
            </div>
          ))}
        </div>

        <div className="workspace-divider" />

        <div
          className="workspace-item hstack justify-content-center"
          style={{ height: 40 }}
          onClick={() => setActive("addMore")}
        >
          <FiPlus />
        </div>

        <div className="workspace-bottom">
          <div
            className="profile-avatar"
            onClick={() => setShowProfile(!showProfile)}
          >
            <img
              src="https://i.pravatar.cc/40"
              className="rounded-1"
              alt="profile"
            />
            <span className="status-dot" />
          </div>

          {showProfile && (
            <>
              <div
                className="profile-overlay"
                onClick={() => setShowProfile(false)}
              />
              <ProfilePopover
                currentUser={currentUserData}
                onViewProfile={() => {
                  setSelectedProfile(currentUserData);
                  setShowProfile(false);
                }}
              />
            </>
          )}
        </div>
      </aside>

      {active === "team" && (
        <TeamWorkspace
          currentUserData={currentUserData}
          selectedProfile={selectedProfile}
          setSelectedProfile={setSelectedProfile}
        />
      )}
      {active === "crmManagement" && <CRMManagement />}
      {active === "hrManagement" && <HRManagement />}
      {active === "accountManagement" && <AccountManagement />}
    </div>
  );
};

export default AppLayout;
